import { InputText, InputTextProps } from 'ui/inputs';
import { FormFieldProps } from 'ui/formField';
import { StyledFormField } from '../SmsSmartOptIn.styled';

type Props = Pick<
  FormFieldProps,
  'errorText' | 'hasError' | 'helpText' | 'labelText' | 'restrictionText'
> &
  Pick<InputTextProps, 'id' | 'onChange' | 'value' | 'maxLength'>;

export const InputTextFormField = ({
  id,
  errorText,
  hasError,
  helpText,
  labelText,
  onChange,
  maxLength = 255,
  restrictionText,
  value,
}: Props) => {
  return (
    <StyledFormField
      data-test={id}
      errorText={errorText}
      hasError={hasError}
      helpText={helpText}
      labelText={labelText}
      restrictionText={restrictionText}
    >
      <InputText id={`${id}-input`} onChange={onChange} value={value} maxLength={maxLength} />
    </StyledFormField>
  );
};
